export default __webpack_public_path__ + "assets/images/00a7e92cbdac1c30d8e13460d27109df.png";